import { Modal, Spinner } from "capitalrx-components-2.0/lib/general";
import { Stack } from "capitalrx-components-2.0/lib/layout";
import { Body, Semibold } from "capitalrx-components-2.0/lib/typography";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const TRANSLATION_PATH = "DIRECT_MEMBER_REIMBURSEMENT.directMemberReimbursementLoadingModal";

const ModalNoTitle = styled(Modal)`
  && .stack.space-medium-large {
    gap: 0 !important;
  }
`;
interface SubmissionLoadingModalProps {
  isVisible: boolean;
}

export const SubmissionLoadingModal = (props: SubmissionLoadingModalProps) => {
  const { isVisible } = props;
  const { t: translate } = useTranslation();

  return (
    <ModalNoTitle visible={isVisible} size="wide">
      <Stack alignment="center" spacing="small">
        <Spinner color="turquoise" size="large" />
        <Stack.Spacer />
        <Semibold>{translate(`${TRANSLATION_PATH}.claimIsBeingSubmitted`)}</Semibold>
        <Body>{translate(`${TRANSLATION_PATH}.doNotRefresh`)}</Body>
      </Stack>
    </ModalNoTitle>
  );
};
